<template>
  <!-- レポート作成 -->
  <div id="HSTDailySummary">
    <div id="container">
      <div class="labelTitle lable">睡眠時無呼吸検査　携帯用装置　自宅配送サービス　集計表</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable" style="width:600px;">
          <tr>
            <th>対象日</th><td style="width:400px;"><input type="date" v-model="startDate"/> ～ <input type="date" v-model="endDate"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>

      </div>
      <!-- 検索結果 -->
      <div v-if="data.length > 0">
        <div class="button-area">
          <b-button class="clipboadCopyButton is-primary" @click="clipboardCopy('hstDailySummaryTable')">クリップボードにコピー</b-button>
        </div>
        <div class="table-wrapper">
            <table id="hstDailySummaryTable">
                <tr>
                  <td rowspan="3" style="width:100px;border-bottom: 5px double;">日付</td>
                  <td rowspan="3" style="border-bottom: 5px double;">曜日</td>
                  <td rowspan="3" style="border-bottom: 5px double;">備考</td>
                  <td v-for="(row, index) in hstList" :key="index" :colspan="row.colspan">
                    {{row.label1}}
                  </td>
                </tr>
                <tr>
                  <td v-for="(row, index) in hst2List" :key="index" :colspan="row.colspan">
                    {{row.label1}}
                  </td>
                </tr>
                <tr style="border-bottom: 5px double;">
                  <td v-for="(row, index) in hst3List" :key="index" :colspan="row.colspan">
                    {{row.label2}}
                  </td>
                </tr>
                <tbody>
                    <tr v-for="(row, index) in data" :key="index">
                        <td>{{convertDay(row.targetDate)}}</td>
                        <td>{{row.dow}}</td>
                        <td>{{getHoliday(row)}}</td>
                        <td v-for="(col, index) in hst3List" :key="index">
                          {{getData(row, col)}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="button-area">
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
const holiday_jp = require("@holiday-jp/holiday_jp");
const philipsHolidays = require('@/components/mock/base/philipsHollday.json')
import {choicesType} from "@/components/mock/base/const.js";
export default {
  name: "HSTDailySummary",
  methods: {
    doSearch: function() {
      if (!this.inputCheck()) {
        return;
      }

      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalSpreadsheet.getSpreadsheetDeliveryServicePOST({
            body: {
              targetPeriodStart: _this.startDate,
              targetPeriodEnd: _this.endDate
            }
          });
        },
        function(result){
          _this.data = result.obj
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    clipboardCopy: function(elementId) {
      console.log(elementId);
      var btable = document.getElementById(elementId);
      var tbody = btable.getElementsByTagName("tbody")[0];
      navigator.clipboard.writeText(tbody.innerText).then(() => {
          this.showMessage("クリップボードにコピーしました。");
        }).catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
    back: function() {
      this.$router.go(-1);
    },
    getTableDefine: function() {
      var hstList = this.getChoiceList(choicesType.hstKind, true)
      // TODO ホルター実装
      // var holterList = this.getChoiceList(choicesType.holterKind, true)
      let cannulaList = this.getChoiceList(choicesType.cannulaSize, true)
      let beltList = this.getChoiceList(choicesType.beltSize, true)

      for (var hst of hstList) {        
        hst.columns = []
        hst.columns.push({
          label1: '件数',
          columns: [
            {
              choicesType: choicesType.hstKind,
              value: hst.value,
              paramName: 'requestCount',
              label2: '依頼'
            },
            {
              choicesType: choicesType.hstKind,
              value: hst.value,
              paramName: 'shippingCount',
              label2: '出荷'
            }
          ]
        });

        if (hst.label1.match(/スマートウォッチ/)) {
          cannulaList.forEach(cannula => {
            cannula.choicesType = choicesType.cannulaSize
          })
          hst.columns.push({
            label1: 'カニューラ数',
            columns: cannulaList
          })

          beltList.forEach(belt => {
            belt.choicesType = choicesType.beltSize
          })
          hst.columns.push({
            label1: 'ベルト数',
            columns: beltList
          })
        }

        hst.columns.push({
          label1: '件数',
          columns: [
            {
              choicesType: choicesType.hstKind,
              value: hst.value,
              paramName: 'returnCount',
              label2: '返却'
            },
            {
              choicesType: choicesType.hstKind,
              value: hst.value,
              paramName: 'psgCount',
              label2: '解析'
            }
          ]
        });
        
      }

      for (var hst of hstList) {
        var colspan = 0;
        for (var column of hst.columns) {
          column.colspan = column.columns.length
          colspan += column.colspan 
        }
        hst.colspan = colspan
      }
      return hstList;
      /* TODO ホルター実装
      for (var holter of holterList) {        
        holter.columns = []
        holter.columns.push({
          label1: '件数',
          columns: [
            {
              choicesType: choicesType.holterKind,
              value: holter.value,
              paramName: 'requestCount',
              label2: '依頼'
            },
            {
              choicesType: choicesType.holterKind,
              value: holter.value,
              paramName: 'shippingCount',
              label2: '出荷'
            }
          ]
        });

        holter.columns.push({
          label1: '件数',
          columns: [
            {
              choicesType: choicesType.holterKind,
              value: holter.value,
              paramName: 'returnCount',
              label2: '返却'
            },
            {
              choicesType: choicesType.holterKind,
              value: holter.value,
              paramName: 'holterCount',
              label2: '解析'
            }
          ]
        });
      }

      for (var holter of holterList) {
        var colspan = 0;
        for (var column of holter.columns) {
          column.colspan = column.columns.length
          colspan += column.colspan 
        }
        holter.colspan = colspan
      }

      return hstList.concat(holterList);
      */
    },
    getData: function(row, col) {
      var result = null;

      switch(col.choicesType) {
        case choicesType.hstKind:
          var machine = row.hst.find(item => {
            return item.value == col.value
          })
          if (machine) {
            result = machine[col.paramName];
          }
          break

        case choicesType.cannulaSize:
          var cannula = row.cannula.find(item => {
            return item.value == col.value
          })
          if (cannula) {
            result = cannula.cannulaCount;
          }
          break

        case choicesType.beltSize:
          var belt = row.belt.find(item => {
            return item.value == col.value
          })
          if (belt) {
            result = belt.beltCount;
          }
          break
        default:
          result = 0;
      }

      return result;
    },
    getHoliday: function(row) {
      var holiday = '休'

      if (row.dow == '土' || row.dow == '日') {
        return holiday
      }

      var date = new Date(row.targetDate)
      if(holiday_jp.between(date, date).length != 0){
        return holiday
      }
      var formatedDay = this.MM_hyp_dd(date);
      if(philipsHolidays.everyyear.includes(formatedDay)){
        return holiday
      }
      if(philipsHolidays.irregular.includes(formatedDay)){
        return holiday
      }
    },
    convertDay: function(day) {
      return day.replaceAll('-','/')
    },
    inputCheck: function() {

      if (!this.startDate || !this.endDate) {
        this.showErrorMessage('対象日を入力してください。');
        return false
      }

      if (this.startDate > this.endDate) {
        this.showErrorMessage('対象日の開始/終了の関係に誤りがあります。');
        return false
      }

      var diff = new Date(this.endDate) - new Date(this.startDate)
      var day = diff / 1000 /60 / 60 / 24
      if (day > 365) {
        this.showErrorMessage('対象日の期間は1年以内で入力してください。');
        return false
      }
      
      return true
    }
  },
  data() {
    var hstList = this.getTableDefine(); 
    var hst2List = [] // ヘッダ2階層
    var hst3List = [] // ヘッダ3階層
    hstList.forEach(row => {
      hst2List = hst2List.concat(row.columns)
      row.columns.forEach(row2 => {
        hst3List = hst3List.concat(row2.columns)
      })
    });

    return {
      data: [],
      hstList: hstList,
      hst2List: hst2List,
      hst3List: hst3List,
      startDate: null,
      endDate: null
    };
  },
  filters: {},
  components: {}
};
</script>
<style lang="scss" scoped>
input {
  width: 200px;
}
.table-wrapper {
    max-height: 1100px;
    overflow-y: scroll;
}
#hstDailySummaryTable {
    font-size: 100% !important;
}
#hstDailySummaryTable tr,
#hhstDailySummaryTable th,
#hstDailySummaryTable td{
    border: black 1px solid;
    text-align: center;
}
#hstDailySummaryTable td{
    width: 60px;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/spreadSheet/HSTDailySummary.vue